import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { submitNewCheckinDate, closeModal, beginCheckinDateProcess, toggleModal, changeCheckinDateFailure, changeCheckinDateRemoveErrors } from '../../redux/actions';
import { DatePicker, Modal } from '../index';
import { Router } from '../../routes';
import { axiosInstance, LoaderFontain, slugify } from '../../utils';

import {
  CalendalModalContainer,
  CalendalModalHeader,
  CalendalModalText,
  CalendalModalMainInfoContainer,
  CalendalModalMainInfo,
  CalendalModalButton,
  CalendalModalButtonContainer
} from './styles';

const mapStateToProps = state => ({
  checkinDate: state.bookingManagement.hotel.checkinDate,
  productId: state.bookingManagement.hotel.productId,
  market: state.bookingManagement.hotel.neighborhood,
  hotelName: state.bookingManagement.hotel.hotelName,
  productName: state.bookingManagement.hotel.productName,
  productType: state.bookingManagement.hotel.productType,
  productAmount: state.bookingManagement.hotel.productAmount,
  bookingId: state.bookingManagement.hotel.bookingId,
  changeDate: state.bookingManagement.changeCheckingDate,
  changeSuccess: state.bookingManagement.status,
  refundAmount: state.bookingManagement.changeCheckingDate.refundAmount,
  refundCredits: state.bookingManagement.changeCheckingDate.refundCredits,
  cardLast4: state.bookingManagement.changeCheckingDate.cardLast4,
  cardName: state.bookingManagement.changeCheckingDate.cardName,
  error: state.bookingManagement.error,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleCheckinDateSubmit: submitNewCheckinDate,
  handleCloseButtonClick: closeModal,
  storeCheckinDateProcessData: beginCheckinDateProcess,
  toggleCheckingModal: toggleModal,
  setErrors: changeCheckinDateFailure,
  removeErrors: changeCheckinDateRemoveErrors
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class CalendarModal extends Component {
  static propTypes = {
    checkinDate: PropTypes.string,
    handleCheckinDateSubmit: PropTypes.func,
    handleCloseButtonClick: PropTypes.func,
    storeCheckinDateProcessData: PropTypes.func,
    toggleCheckingModal: PropTypes.func,
    productId: PropTypes.number,
    productAmount: PropTypes.number,
    productType: PropTypes.number,
    bookingId: PropTypes.number,
    changeDate: PropTypes.instanceOf(Object),
    market: PropTypes.string,
    hotelName: PropTypes.string,
    productName: PropTypes.string,
    changeSuccess: PropTypes.string,
    cardName: PropTypes.string,
    refundAmount: PropTypes.number,
    refundCredits: PropTypes.number,
    cardLast4: PropTypes.number,
    error: PropTypes.string,
  };

  state = {
    step: 1,
    calendarData: {},
    loading: true,

  };

  async componentDidMount() {
    const { setUpProduct } = this;

    const calendarData = await setUpProduct();

    this.setState({
      ...calendarData,
      loading: false,
      newDate: null,
    });
  };

  async componentDidUpdate() {
    const { changeSuccess } = this.props;
    const { step } = this.state;

    if(changeSuccess === 'success' && step !== 3) {
      this.setState({
        step: 3,
      });
    }
  };

  toggleLoading = () => {
    this.setState((prevState) => ({
      loading: !prevState.loading,
    }));
  };

  handleDayChange = async date => {
    const { bookingId, storeCheckinDateProcessData, setErrors, removeErrors } = this.props;
    const { toggleLoading } = this;
    const newDate = moment(date).format('YYYY-MM-DD');
    let data;
    await toggleLoading();
    try {
      const res = await axiosInstance.get(`/bookings/checkin`,{
        params: {
          bookingId,
          newDate,
        }
      });
      data = res.data;
      const { type, diff, tax } = data;
      storeCheckinDateProcessData({ type, diff, tax, newDate })
      this.setState({
        step: 2,
        newDate,
      });
      removeErrors();
      await toggleLoading();
    } catch (e) {
      setErrors(e.error);
      await toggleLoading();
    }
  };

  setUpProduct = async () => {
    const { productId, productAmount } = this.props;
    const { data: calendar } = await axiosInstance.get(`products/tickets/${productId}`);

    const unavailableDates = calendar.capacity
      .filter(disabledDate => disabledDate.tickets === 0 || disabledDate.tickets < productAmount)
      .reduce((acc, curr) => [...acc, curr.date], []);

    const availableDates = calendar.capacity
      .filter(dateInfo => dateInfo.tickets !== 0 && dateInfo.tickets >= productAmount)
      .reduce((acc, curr) => ({
        ...acc,
        [curr.date]: curr.tickets,
      }), {});

    return {
      calendarData: {
        ...calendar,
        capacity: availableDates,
        unavailableDates: [...new Set(unavailableDates)],
      },
    };
  };

  setNewCheckInDate = () => {
    const { newDate } = this.state;
    const { handleCheckinDateSubmit, changeDate: { type }, market, hotelName, productName, productId, toggleCheckingModal } = this.props;

    if(type < 2) {
      handleCheckinDateSubmit(newDate);
    } else {
      toggleCheckingModal();
      Router.pushRoute(
        'checkout-hotel',
        {
          marketName: slugify(market),
          hotelName: slugify(hotelName),
          productName: slugify(productName),
          productId
        }
      );
    }
  };

  render() {
    const { handleDayChange, setNewCheckInDate } = this;
    const { checkinDate, productType, handleCloseButtonClick, changeDate: { diff, type, tax }  } = this.props;
    const { step, calendarData, loading, newDate } = this.state;
    const typeOfAdditionalPayment = type === 2 ? 'charged' : 'refunded';
    const { refundAmount, refundCredits, cardLast4, changeSuccess, error, cardName } = this.props;

    return (
      <Modal empty>
        {loading && <LoaderFontain height={240} />}
        {step === 1 && !loading && (
          <DatePicker
            selectedDate={checkinDate}
            handleDayClick={handleDayChange}
            calendarData={calendarData}
            needShowPasses
            productType={productType}
          />
        )}
        {step === 2 && (
          <CalendalModalContainer>
            <CalendalModalHeader>Check-in Date Change</CalendalModalHeader>
            <CalendalModalMainInfoContainer>
              <CalendalModalMainInfo>Check-in Date: {moment(newDate).format('MMMM DD, YYYY')} </CalendalModalMainInfo>
              <CalendalModalMainInfo>Price Difference: <span>${(diff + tax).toFixed(2)}</span> {(diff + tax) > 0 ? typeOfAdditionalPayment : ''}</CalendalModalMainInfo>
            </CalendalModalMainInfoContainer>
            {type !== 0 && (
              <CalendalModalText>
                Pressing submit finalizes your selection and you will be {typeOfAdditionalPayment} a <span>${(diff + tax).toFixed(2)}</span> difference in price using your credit card on file.
              </CalendalModalText>
            ) || ( <CalendalModalText>Pressing submit finalizes your selection</CalendalModalText> )}
            <CalendalModalText>Note: changes within {process.env.CANCELING_HOURS} hours of check-in date are final.</CalendalModalText>
            {!error && (
              <CalendalModalButtonContainer>
                <CalendalModalButton btnType="secondary" htmlType="button" onClick={handleCloseButtonClick}>Cancel</CalendalModalButton>
                <CalendalModalButton btnType="primary" htmlType="submit" onClick={setNewCheckInDate}>Submit</CalendalModalButton>
              </CalendalModalButtonContainer>
            )}
          </CalendalModalContainer>
        )}
        {step === 3 && (
          <CalendalModalContainer>
            <CalendalModalHeader>Check-in Date Change</CalendalModalHeader>
            <CalendalModalMainInfoContainer>
              <CalendalModalMainInfo>Check-in Date: {moment(newDate).format('MMMM DD, YYYY')} </CalendalModalMainInfo>
            </CalendalModalMainInfoContainer>
            <CalendalModalText>
              Date change {`${changeSuccess === 'success' ? 'succeeded' : 'failed'}`}
            </CalendalModalText>
              {refundCredits + refundAmount > 0 && changeSuccess === 'success' && (
                <CalendalModalText>
                  You will be refunded
                  {`${refundCredits > 0 ? ` $${refundCredits.toFixed(2)} on credits` : ''}`}
                  {refundAmount > 0 && refundCredits > 0 && (' and ')}
                  {refundAmount > 0 && cardName !== 'PAYPAL' && ` $${refundAmount.toFixed(2)} on card which ends with ${cardLast4}`}
                  {refundAmount > 0 && cardName === 'PAYPAL' && ` $${refundAmount.toFixed(2)} on paypal`}
                </CalendalModalText>
              )}
              {!error && (
                <CalendalModalButtonContainer>
                  <CalendalModalButton btnType="primary" htmlType="submit" onClick={handleCloseButtonClick}>Done</CalendalModalButton>
                </CalendalModalButtonContainer>
              )}
          </CalendalModalContainer>
        )}
        {error && (
          <CalendalModalText error>
            <span>
              {error}
            </span>
          </CalendalModalText>
        )}
      </Modal>
    );
  }
}

export default CalendarModal;
